import mySqlToLocal from "./mySqlToLocal"
import dayjs from "dayjs"

const shouldSessionFullSync = (sessionEndsAt) => {
  const sessionExpiryDate = mySqlToLocal(sessionEndsAt)
  const daysSinceExpiry = dayjs().diff(sessionExpiryDate, "day")

  return daysSinceExpiry <= 7
}

export default shouldSessionFullSync